import { render, staticRenderFns } from "./TypeList.vue?vue&type=template&id=7944ef5a&scoped=true"
import script from "./TypeList.vue?vue&type=script&lang=ts"
export * from "./TypeList.vue?vue&type=script&lang=ts"
import style0 from "./TypeList.vue?vue&type=style&index=0&id=7944ef5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7944ef5a",
  null
  
)

export default component.exports